module.exports = __webpack_public_path__ + "img/logo.da77a2da.svg";